module.exports = __webpack_public_path__ + "img/skor_presensi.b9a4d260.png";